module.exports = __webpack_public_path__ + "media/images/pic/courses/benefit03-07f291dfd75fe18d976562d9ef64da48.svg";